import { useQuery } from '@tanstack/react-query';
import { usePrivy } from '@privy-io/react-auth';
import { fetchSubmissionCategories } from '@/lib/api';
import type { SubmissionCategory } from '@/lib/types';

export function useSubmissionCategories() {
  const { getAccessToken } = usePrivy();
  return useQuery<SubmissionCategory[]>({
    queryKey: ['submissionCategories'],
    queryFn: async () => {
      const token = await getAccessToken();
      if (!token) throw new Error('No Privy session');
      return fetchSubmissionCategories(token);
    },
    staleTime: 30_000,
  });
}
